export default {
  app: {
    title: "React template",
  },
  refresh: {
    title: "Are you active?",
    cta: "You were registered as not active, please confirm that you are active in the next minute, if you don't you will be logged out.",
  },
  common: {
    language: "Jezik",
    english: "Engleski",
    serbian: "Srpski",
    dataGridExample: "Primer Data Grid-a",
    close: "Close",
    trademark: "TM",
    search: "Pretraga",
    error: "Greška",
    continue: "Nastavite",
    labelUsername: "Korisničko ime",
    labelEmail: "E-mail",
    labelPassword: "Šifra",
    next: "Napred",
    nextPage: "Sledeća stranica",
    previousPage: "Predhodna stranica",
    back: "Nazad",
    goBack: "Idite nazad",
    ok: "U redu",
    done: "Gotovo",
    confirm: "Potvrdite",
    printDownload: "Print/Download",
    cancel: "Cancel",
    remove: "Remove",
    invite: "Invite",
    save: "Save",
    complete: "Complete",
    download: "Download",
    yes: "Yes",
    no: "No",
    to: "to",
    select: "Select...",
    none: "None",
    date: {
      range: "{{start}} do {{end}}",
    },
    logout: "Izloguj se",
    seeMore: "Vidi još",
    contactUs: "Kontaktirajte nas",
    tryForFree: "Probajte besplatno",
    supportLink: "im.support@tremium.net",
    martketingLink: "marketing@tremium.net",
    phoneNumber: "+38160 366 02 71",
  },

  notifications: {
    title: "Obaveštenja",
  },
  pages: {
    home: "Početna",
    login: "Login",
    register: "Register",
    forgotPassword: "Zaboravljena lozinka",
    error: "Pogrešna stranica",
    notFound: "Nije pronađena stranica",
    profile: "Profilna stranica",
    settings: "Podešavanja",
    contact: "Kontakt",
    dashboard: "Komandna tabla",
    about: "O nama",
    careers: "Posao",
  },
  register: {
    registerTitle: "Register",
    usernameRequired: "Username is required.",
    emailFormat: "Invalid email address format.",
    emailRequired: "An email or username is required.",
    passwordLength: "Your password contain between 8 and 50 characters.",
    passwordRequired: "A Password is required.",
  },
  login: {
    welcome: "React template",
    dontHaveAccount: "Nemate nalog? ",
    emailFormat: "Loš format email-a",
    emailRequired: "Email/korisničko ime je obavezno",
    noUsers: "Ne postoji korisnik",
    passwordStrength: "Your password is {{strength}}.",
    passwordLength: "Your password contain between 8 and 50 characters.",
    signUpRecommendation: "Registrujte se",
    email: "Please enter your email address or username to log in:",
    logInTitle: "Prijava",
    logIn: "Ulogujte se",
    signUp: "Sign Up",
    usernameRequired: "Username is required.",
    passwordRequired: "A Password is required.",
    forgotYourPassword: "Zaboravili ste šifru?",
    forgotPasswordEmail: "Email",
    useDifferentEmail: "Use different email address or username",
  },
  password: {
    weak: "weak",
    average: "average",
    good: "good",
    strong: "strong",
  },
  forgotPassword: {
    title: "Forgot Password",
    label: "Send email",
    emailRequired: "An email is required.",
    emailFormat: "Invalid email address format.",
    forgotPassword: {
      title: "Forgot Password",
      subtitle:
        "Please answer the security question to gain access to your account:",
      label: "Reset Password",
    },
  },
  notFound: {
    text: "We're sorry but we couldn't find the page you were looking for.",
    goBack: "Go back to homepage",
  },
  errorPage: {
    text: "We're sorry, an internal server error came up. Please be patient or try again later.",
    goBack: "Go back to homepage",
    logout: "Logout",
  },
  apiErrors: {
    ClientIpAddressIsNullOrEmpty: "Client Ip address is null or empty",
    UsernameDoesNotExist: "Username does not exist",
    WrongCredentials: "Wrong credentials",
    SomethingWentWrong: "Something went wrong",
    WrongPasswordAccountIsLocked: "Wrong credentials, account is locked",
    AccountIsLocked: "Account is locked",
  },
  date: {
    timespan: {
      yearsAgo: "Pre {{years}} godine",
      monthsAgo: "Pre {{months}} meseca",
      daysAgo: "Pre {{days}} dana",
      hoursAgo: "Pre {{hours}} sata",
      minutesAgo: "Pre {{minutes}} minuta",
      secondsAgo: "Pre {{seconds}} sekunde",
      now: "Upravo sada",
    },
  },
  dashboard: {
    charts: {
      lineChart: "Linijski grafikon",
      pieChart: "Kružni grafikon",
      barChart: "Dijagram",
      radarChart: "Radarski grafikon",
    },
  },
  profile: {
    image: "Slika profila",
    chooseImage: "Izaberi sliku za profil",
    form: {
      step1: "Lični podaci",
      step2: "Adresa",
      step3: "Posao",
    },
    labels: {
      firstName: "Ime",
      lastName: "Prezime",
      gender: "Pol",
      city: "Grad",
      street: "Ulica",
      postalCode: "Poštanski broj",
      companyName: "Ime firme",
      companyAddress: "Adresa firme",
      yearsInCompany: "Broj godina u firmi",
    },
  },
  header: {
    navItems: {
      item1: "Početna",
      item2: "Benefiti",
      item3: "Pomoć",
      item4: "Kontakt",
      item5: "Prijavite se",
    },
  },
  footer: {
    text: "Inspect Master <3> Copyright © 2023 </3> <1></1> <2> Tremium Software.</2> Sva prava zadržana.",
    supportLink: "im.support@tremium.net",
    navItems: {
      item1: "Početna",
      item2: "Benefiti",
      item3: "Demo",
      item4: "Pomoć",
      item5: "Politika privatnosti",
      item6: "Kontakt",
    },
  },
  sectionHero: {
    title: "Provera procesa. Automatizacija kontrole. Ušteda vremena.",
    text: "Inspect Master predstavlja rešenje za sve Vaše potrebe u oblasti provere bezbednosnih uslova na radu. Naša platforma pruža automatizaciju, standardizaciju i sistematsko vođenje podataka, rešavajući ključne izazove sa kojima se tradicionalni procesi provere suočavaju.",
    buttonLabel: "Kontaktirajte nas",
  },
  sectionWhy: {
    title: "Zašto baš Inspect Master?",
    cards: {
      card1: {
        title: "Automatizacija",
        text: "Proces provere je automatizovan od samog početka provere do pravljenja stručnog nalaza kao krajnjeg proizvoda. Automatizacija procesa štedi vreme i pruža efikasnost u radu.",
      },
      card2: {
        title: "Prilagodljivost",
        text: "Koristeći personalizovane šablone, naša platforma omogućava prilagođavanje procesa provere bilo kom tipu ispitivanja.",
      },
      card3: {
        title: "Bez grešaka",
        text: "Pripremom šablona koji precizno vode kroz proces provere smanjujete mogućnost greške i povećavate efikasnost u radu.",
      },
      card4: {
        title: "Ušteda vremena",
        text: "Zaboravite na vremenski zahtevne procedure i dugotrajno kreiranje izveštaja. Inspect Master automatski generiše stručne nalaze i izveštaje, štedeći vreme za unos i obradu podataka.",
      },
      card5: {
        title: "Administracija i struktura",
        text: "Naša aplikacija nudi jednostavno upravljanje svim parametrima potrebnim za kreiranje nalaza. Stručni nalaz je glavni dokument aplikacije, a naš sistem omogućava pretragu i filtriranje podataka prema Vašim potrebama.",
      },
    },
  },
  sectionInfo: {
    text: "Ručno vođenje podataka i nedostatak dokumentacije postaju prošlost uz naše softversko rešenje. Inspect Master omogućava brz i efikasan unos podataka putem računara, telefona i tableta čime se olakšava rad na terenu. <br /><br /> U cilju ubrzanja i standardizacije procesa provere, naša aplikacija generiše stručni nalaz kreiran prema unapred napravljenim šablonima i u skladu sa važećim propisima.",
  },
  sectionMakePossible: {
    title: "Šta omogućava <br /> Inspect Master?",
    items: [
      "Mogućnost unošenja rezultata ispitivanja kroz tekst, sliku ili tabelu",
      "Formiranje stručnog nalaza nakon unošenja podataka ispitivanja",
      "Eksportovanje stručnih nalaza u PDF formatu",
      "Automatsko slanje stručnih nalaza putem e-maila",
      "Mogućnost kopiranja postojećih nalaza",
      "Korišćenje uređaja za brzi unos podataka",
      "Arhiviranje stručnih nalaza i čuvanje rezervnih kopija na cloud-u",
      "Mogućnost kreiranja šablona koji služi za automatizaciju provere procesa i opreme za rad prema zahtevima i standardima specifičnim za određenu industriju",
      "Pretraga i brz pristup svim stručnim nalazima",
    ],
  },
  sectionTrial: {
    title: "Registrujte se prvih mesec <br /> dana besplatno!",
    text1: "Besplatna verzija uključuje:",
    text2:
      "Nakon isteka perioda od mesec dana, kontaktirajte nas za cenovne ponude i produžetak licence.",
    trialList: [
      "Neograničen broj korisnika i stručnih nalaza",
      "Slanje izveštaja na mejl u momentu zatvaranja nalaza",
      "Podešavanje štampe i pristup šablonima",
      "Kopiranje predmeta ispitivanja i stručnog nalaza",
      "Čuvanje izveštaja na Cloud-u u momentu zatvaranja nalaza",
      "Document management strana",
    ],
  },
  sectionFAQ: {
    title: "Često postavljana pitanja",
    note: "Još uvek imate pitanje?",
    questions: {
      question1: {
        question: "Kako se registrovati na platformu?",
        answer:
          "Uz samo jedan poziv ili mejl! Prvi nalog Vašeg tima na platformi otvara Inspect Master tim za podršku usled čega Vam dodeljuje ulogu administratora. Nakon toga, administrator ima mogućnost da dodaje ostale članove tima dodeljujući im različite uloge u okviru platforme. ",
      },
      question2: {
        question: "Koji su najvažniji segmenti Inspect Mastera?",
        answer:
          "Predmeti ispitivanja koji se sastoje iz više sekcija osnovni su deo aplikacije. Zato se oni kreiraju pre samog ispitivanja kako bi olakšali dalje provere. Pored predmeta ispitivanja, stručni nalazi su krajnji dokument koji se dobija nakon ispitivanja na terenu. Oni se generišu popunjavanjem rezultata ispitivanja na terenu.",
      },
      question3: {
        question: "Kako se predefinišu <i>parametri</i> ispitivanja?",
        answer:
          "U okviru platforme potrebno je definisati neophodne parametre: oblasti rada kojim se kompanija bavi (Tipovi ispitivanja), propise i standarde koji će se odnositi na ispitivanja, instrumente kojima se vrše ispitivanja, kao i klijente za koje se to ispitivanje obavlja. ",
      },
      question4: {
        question: "Kako se predefinišu <i>predmeti</i> ispitivanja?",
        answer:
          "Predmeti ispitivanja se mogu predefinisati na dva načina: uvozom iz zajedničke biblioteke ili samostalnim kreiranjem. Prilikom samostalnog kreiranja nalaza trebalo bi definisati tip nalaza, instrumente kojima se vrši ispitivanje i propise i standarde koji se koriste za ispitivanje. Nakon toga se pripremaju pitanja na koja je potrebno odgovoriti tokom popunjavanja stručnog nalaza. Takođe, moguće je unapred definisati zaključke, kao i odgovore na pitanja kako bi se na terenu optimizovalo vreme potrebno za unos. ",
      },
      question5: {
        question: "Kako se unose rezultati ispitivanja?",
        answer:
          "Odgovori na unapred pripremljena pitanja u stručnom nalazu se unose u vidu teksta, popunjavanjem tabele, u vidu slike ili biranjem jedne od ponuđenih opcija. Na kraju se formira zaključak - bilo pozitivan ili negativan. Jedan stručni nalaz može imati veći broj predmeta ispitivanja.",
      },
      question6: {
        question: "Koje su dodatne funkcionalnosti?",
        answer:
          "Pored primarnih fukcionalnosti, dodatne funkcionalnosti Inspect Mastera su automatsko čuvanje stručnih nalaza i šablona. Stručni nalazi se mogu sačuvati na Cloud-u ili direktno poslati klijentima na e-mail. Velika prednost su i šablonski, unapred definisani odgovori na najčešća pitanja koji se mogu automatski dodati u stručni nalaz, kao i već definisani šabloni ispitivanja.",
      },
    },
  },
  sectionAbout: {
    title: "O nama",
    text: "<1>Pre nekoliko godina javio nam se, sada već naš dugogodišnji partner, sa problemom koji je imao u svakodnevnom poslovanju. Bio mu je potreban alat koji će mu pomoći da optimizuje procese, efikasnije obavlja ispitivanja i generiše stručne nalaze. Tako je nastao Inspect Master - rešenje koje smo osmislili kao odgovor na svakodnevne izazove i problem iz realnog poslovanja u oblasti provere bezbednosnih uslova na radu. </1> <1>Inspect Master je produkt koji razvija tim IT softverske kompanije Tremium Software i na kome na dnevnom nivou radi marljivo unoseći najnovije promene i funkcionalnosti. Trudimo se da ostanemo dosledni potrebama naših partnera, ali i uvedemo dovoljno novina kako bismo proširili namenu naše platforme. </1>",
  },
  sectionContact: {
    title: "Kontaktirajte nas",
    text: "Inspect Master Vam daje mogućnost da odaberete funkcionalnosti koje najviše odgovaraju Vašim potrebama. Za informacije o cenovnim ponudama, kao i besplatnoj probnoj registraciji, kontaktirajte nas na mejl: <1>im.support@tremium.net</1> ili pozivom na broj telefona <2>+38160 366 02 71</2>",
  },
  privacyPolicy: {
    title: "Politika privatnosti",
    lastUpdate: "Poslednje ažuriranje: 11. mart 2025.",
    text: "Ova Politika privatnosti definiše uslove pod kojima Inspect Master prikuplja, koristi i obrađuje vaše lične podatke kada pristupate ili koristite bilo koji od naših veb-sajtova ili usluga. Ova Politika privatnosti opisuje, između ostalog, vrste ličnih podataka koje prikupljamo, svrhe u koje ih koristimo, kao i vaša prava i obaveze u vezi sa tim podacima.",
    definition: {
      title: "Definicije",
      definitions: [
        "<strong>Nalog</strong> označava jedinstveni korisnički nalog kreiran radi pristupa našoj usluzi ili njenim delovima.",
        "<strong>Proizvod</strong> (u ovom dokumentu označen kao „Proizvod”, „Mi”, „Nas” ili „Naš”) odnosi se na Inspect Master.",
        "<strong>Kolačići</strong> su male datoteke koje veb-sajt postavlja na vaš računar, mobilni uređaj ili neki drugi uređaj, a koje sadrže podatke o vašem pretraživanju na tom veb-sajtu.",
        "<strong>Zemlje</strong> na koje se odnosi: Srbija, Severna Makedonija, Crna Gora, Švajcarska i zemlje Evropske unije.",
        "<strong>Lični podaci</strong> su informacije koje se odnose na identifikovano fizičko lice.",
        "<strong>Podaci o korišćenju</strong> predstavljaju podatke koji se automatski prikupljaju tokom korišćenja usluge ili iz infrastrukture same usluge (npr. trajanje posete određenoj stranici).",
        "<strong>Veb-sajt</strong> se odnosi na Inspect Master, dostupan na domenu <a href='https://www.inspectmaster.net'>www.inspectmaster.net</a>."
      ]},
    personalData: {
      title: "Prikupljanje i korišćenje vaših ličnih podataka",
      subtitle: "Vrste podataka koje prikupljamo",
      personalDataTitle: "Lični podaci",
      personalDataDescription: "Tokom korišćenja naše usluge, možemo tražiti od vas određene informacije koje mogu poslužiti za vašu identifikaciju ili kontaktiranje. Ovi podaci mogu uključivati, ali nisu ograničeni na:",
      personalDataList: [
        "<strong>Email adresu</strong>",
        "<strong>Ime</strong>",
        "<strong>Prezime</strong>",
        "<strong>Broj telefona</strong>",
        "<strong>Naziv kompanije</strong>",
        "<strong>PIB</strong>",
        "<strong>Adresu kompanije</strong>",
        "<strong>Matični broj firme</strong>",
        "<strong>Zvanje</strong>",
        "<strong>Broj licence</strong>",
        "<strong>Sliku potpisa</strong>",
      ],
      usageData: "Podaci o korišćenju",
      usageDataDescription: [
        "Podaci o korišćenju se automatski prikupljaju kada koristite našu uslugu. Ovi podaci mogu uključivati informacije poput IP adrese vašeg uređaja, tipa i verzije pregledača, stranica koje posećujete, vremena i datuma posete, vremena provedenog na stranicama, jedinstvenih identifikatora uređaja i drugih dijagnostičkih podataka.",
        "Ako pristupate usluzi putem mobilnog uređaja, možemo automatski prikupiti dodatne podatke, uključujući, ali ne ograničavajući se na tip mobilnog uređaja, jedinstveni ID uređaja, IP adresu, operativni sistem, tip mobilnog pregledača i druge dijagnostičke podatke.",
      ],
    },
    cookies: {
      title: "Tehnologije praćenja i kolačići",
      text: "Koristimo kolačiće i slične tehnologije za praćenje aktivnosti na našoj usluzi i čuvanje određenih informacija.",
      browserCookiesSubtitle: "Kolačići ili kolačići pregledača",
      browserCookiesText: "Kolačić je mala datoteka koja se postavlja na Vaš uređaj. Možete uputiti svoj pregledač da odbije sve kolačiće ili da Vas obavesti kada se kolačić šalje. Međutim, ako ne prihvatite kolačiće, možda nećete moći da koristite neki deo naših usluga. Osim ako niste podesili svoj pregledač da odbija kolačiće, naše usluge mogu koristiti kolačiće.",
      subtitle: "Vrste kolačića koje koristimo",
      sessionCookiesTitle: "Neophodni kolačići",
      sessionCookiesList: [
        "<strong>Tip:</strong> Kolačići sesije",
        "<strong>Svrha:</strong> Ovi kolačići su neophodni za pružanje usluga dostupnih putem veb-sajta i omogućavanje njegovih funkcionalnosti, uključujući autentifikaciju korisnika i sprečavanje zloupotrebe naloga.",
      ],
      persistentCookiesTitle: "Kolačići za prihvatanje politike kolačića",
      persistentCookiesList: [
        "<strong>Tip:</strong> Trajni kolačići",
        "<strong>Svrha:</strong> Ovi kolačići beleže da li ste prihvatili korišćenje kolačića na našem veb-sajtu.",
      ],
      functionalityCookiesTitle: "Funkcionalni kolačići",
      functionalityCookiesList: [
        "<strong>Tip:</strong> Trajni kolačići",
        "<strong>Svrha:</strong> Ovi kolačići omogućavaju da zapamtimo vaše izbore (npr. podatke za prijavu ili jezičke preferencije) kako bismo vam pružili personalizovano korisničko iskustvo.",
      ],
    },
    usePersonalData: {
      title: "Upotreba vaših ličnih podataka",
      text: "Vaši lični podaci mogu biti korišćeni u sledeće svrhe:",
      list: [
        "<strong>Za pružanje i održavanje naše usluge</strong>, uključujući praćenje njenog korišćenja.",
        "<strong>Za upravljanje vašim nalogom</strong>, omogućavajući vam pristup funkcionalnostima dostupnim registrovanim korisnicima.",
        "<strong>Za komunikaciju sa vama</strong>, putem emaila, telefonskih poziva, SMS-a ili notifikacija aplikacije u vezi sa ažuriranjima, bezbednosnim obaveštenjima i sličnim informacijama.",
        "<strong>Za informisanje o vestima, promocijama i sličnim ponudama</strong>, osim ako ne odlučite da ih ne primate.",
        "<strong>Za obradu i upravljanje vašim zahtevima</strong> koje nam upućujete.",
        "<strong>Za analizu podataka</strong>, praćenje trendova, poboljšanje naše usluge i evaluaciju marketinških kampanja.",
      ],
      share: "Vaše lične podatke možemo deliti u sledećim situacijama:",
      shareList: [
        "<strong>Sa vašim pristankom</strong> - kada ste saglasni sa deljenjem podataka u određene svrhe.",
      ]
    },
    retentionPersonalData:{
      title: "Čuvanje vaših ličnih podataka",
      list: [
        "Kompanija će zadržati i koristiti Vaše lične podatke u meri koja je neophodna da bismo ispunili naše pravne obaveze (na primer, ako smo obavezani da čuvamo Vaše podatke kako bismo se uskladili sa važećim zakonima), rešavali sporove i sproveli naše pravne ugovore i politike.",
        "Kompanija će takođe zadržati podatke o korišćenju za interne analize. Podaci o korišćenju se obično zadržavaju u kraćem vremenskom periodu, osim kada se ovi podaci koriste za jačanje bezbednosti ili poboljšanje funkcionalnosti naših usluga, ili kada smo zakonski obavezani da ih čuvamo duže vreme.",
      ]
    },
    transferPersonalData:{
      title: "Prenos vaših ličnih podataka",
      list: [
        "Korišćenjem naše usluge i dostavljanjem vaših podataka, saglasni ste sa njihovim eventualnim prenosom u druge zemlje. Mi preduzimamo sve razumne mere kako bismo osigurali bezbedan tretman vaših podataka u skladu sa ovom Politikom privatnosti.",
        "U okviru usluge možete ažurirati ili izmeniti svoje podatke kroz podešavanja naloga ili kontaktiranjem naše podrške.",
      ]
    },
    disclosurePersonalData: {
      title: "Otkrivanje vaših ličnih podataka",
      textTitle: "Pravni zahtevi",
      text: "Pod određenim okolnostima, kompanija može biti obavezana da otkrije Vaše lične podatke ako to zahteva zakon ili kao odgovor na važeće zahteve od strane javnih vlasti (npr. sud ili vladina agencija).",
      otherLegalrequirements: "Pravni zahtevi",
      otherLegalrequirementsText: "U određenim situacijama, možemo biti obavezni da otkrijemo vaše podatke u skladu sa zakonom ili na osnovu zahteva državnih organa, uključujući:",
      otherLegalrequirementsList: [
        "Poštovanje zakonskih obaveza",
        "Zaštitu naših prava i imovine",
        "Istrage potencijalnih nezakonitih aktivnosti",
        "Zaštitu sigurnosti korisnika i javnost",
        "Odbranu od pravnih zahteva",
      ],
    },
    securityPersonalData:{
      title: "Bezbednost vaših podataka",
      text: "Vaša privatnost nam je važna, ali imajte na umu da nijedna metoda prenosa podataka preko interneta ili elektronskog skladištenja nije 100% sigurna. Primenićemo komercijalno prihvaćene mere zaštite, ali ne možemo garantovati apsolutnu sigurnost vaših podataka.",
    },
    changesPrivacyPolicy:{
      title: "Izmene ove Politike privatnosti",
      list: [
        "Povremeno možemo ažurirati ovu Politiku privatnosti. Obavestićemo vas o izmenama putem emaila ili istaknutog obaveštenja na našem veb-sajtu. Savetujemo vam da povremeno pregledate ovu Politiku radi eventualnih izmena.",
      ]
    },
    contact:{
      title: "Kontakt informacije",
      text: "Ukoliko imate pitanja u vezi sa ovom Politikom privatnosti, možete nas kontaktirati putem emaila:",
    },
  },
};
